import React, { useEffect, useState } from 'react';
import { CircularProgress, Typography, Divider, Button, Paper, Box, GridList, GridListTile, GridListTileBar,
  Tooltip, Tabs, Tab } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import Image from 'material-ui-image';
import { Switch, Route, Link, useHistory, useParams } from 'react-router-dom';
import { ImageForm } from './';
import IImage from './Image';
import AddIcon from '@material-ui/icons/Add';
import Pagination from '@material-ui/lab/Pagination';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';

import {
  STORAGE_ACCOUNT_NAME as storageAccountName,
  STORAGE_EMAIL_CONTAINER as storageEmailContainer,
  STORAGE_PRINT_CONTAINER as storagePrintContainer
} from '../../config';
import { useGetAllImagesQuery } from '../../apis/backend';


const useStyles = makeStyles(theme => ({
  imageList: {
    display: 'flex',
    alignContent: 'center',
    padding: theme.spacing(0),
    '& .MuiButton-root': {
      justifySelf: 'start',
    },
    '& #summary': {
      flex: 1,
      display: 'flex',
      justifyContent: 'flex-end',
      alignSelf: 'center'
    },
  },
  imageGrid: {
    padding: theme.spacing(3, 0),
    '& .MuiGridListTileBar-rootSubtitle': {
      height: 'auto',
      padding: theme.spacing(2,0),
      width: '100%',
    },
  },
  pagination: {
    alignSelf: 'center',
    marginTop: theme.spacing(3),
  },
  divider: {
  }
}));

const Imagebank = () => {
  const chainId = useSelector(state => state.doris.selectedChain);
  const siteId = useSelector(state => state.doris.selectedSite);

  const [currentContainer, setCurrentContainer] = useState();
  const [page, setPage] = useState(1);
  const [selectedTab, setSelectedTab] = useState(0);

  const history = useHistory();
  let { imageType } = useParams();
  const { t } = useTranslation();
  const classes = useStyles();

  const limit = 10;

  const skipGetAllImages = !(chainId && siteId && imageType);
  const { data: imagesResult, isLoading, isFetching, error } = useGetAllImagesQuery({ chainId, siteId, type: imageType, page: page - 1, limit }, { skip: skipGetAllImages });

  useEffect(() => {
    const containerName = imageType == 'print'
      ? storagePrintContainer
      : storageEmailContainer;
    setCurrentContainer(containerName);
    setPage(1);
  }, [imageType]);

  useEffect(() => {
    const tabs = ['print', 'email'];
    setSelectedTab(tabs.indexOf(imageType));
  }, []);

  if (error) console.error(JSON.stringify(error.data));

  const imageGrid = (
    <>
      <Box display="flex" flexDirection="column">
        {imagesResult?.images?.length == 0 && (
          <Box
            fullWidth
            height={105}
            p={4}
            display="flex"
            alignItems="center"
            justifyContent="center">
            <Typography
              color="primary"
              variant="body1">No images</Typography>
          </Box>
        )}
        {imagesResult?.images?.length >= 1 && (
          <GridList
            className={classes.imageGrid}
            cellHeight={'auto'}
            spacing={24}
            cols={5}>
            {imagesResult?.images?.map(image => {
              return (
                <Tooltip
                  key={image.file_name}
                  arrow={true}
                  title={<Typography variant="subtitle1">{image.file_name}</Typography>}>
                  <GridListTile>
                    <Link to={{ pathname: `/imagebank/${imageType}/${image.id}`, state: { image: image} }}>
                      <Image cover src={`https://${storageAccountName}.blob.core.windows.net/${currentContainer}/${image.file_path}`} />
                      <GridListTileBar title={image.name} subtitle={`${image.created} (${image.file_size/ 1000} KB)`} />
                    </Link>
                  </GridListTile>
                </Tooltip>
              );
            })}
          </GridList>
        )}

        <Divider className={classes.divider} />
        <Pagination
          className={classes.pagination}
          onChange={(event, page) => setPage(page)}
          page={page}
          count={imagesResult?.total ? Math.ceil(imagesResult.total/limit) : 0}
          variant="outlined"
          shape="rounded" />
      </Box>
    </>
  );

  return (
    <>
      <Paper elevation={2}>
        <Box p={4}>
          <Switch>

            <Route exact path="/imagebank/add">
              <Typography variant="h4">Add Image</Typography>
              <Divider />
              <ImageForm imageType={imageType} />
            </Route>

            <Route exact path="/imagebank/:imageType">

              <Box display="flex">
                <Box flex="1">
                  <Typography variant="h4">{t('imagebank')}</Typography>
                </Box>
                <Box justifySelf="right">
                  { imageType !== 'email' && (
                    <Button
                      variant="contained"
                      color="primary"
                      startIcon={<AddIcon />}
                      onClick={() => history.push({
                        pathname: '/imagebank/add',
                        state: { imageType }
                      })}>
                        Upload Image
                    </Button>
                  )
                  }
                </Box>
              </Box>

              <Tabs
                value={selectedTab}
                wrapped
                textColor="primary"
                indicatorColor="primary"
                onChange={(event, newValue) => {
                  const tabs = ['print', 'email'];
                  setSelectedTab(newValue);
                  history.push({ pathname: `/imagebank/${tabs[newValue]}`});
                }}>
                <Tab label={t('print')} />
                <Tab label={t('email')} />
              </Tabs>

              <Divider className={classes.divider} />

              { (isFetching || isLoading) && (<Box width="100%">
                <Box
                  p={4}
                  display="flex"
                  alignItems="center"
                  justifyContent="center">
                  <CircularProgress />
                  <Typography
                    color="primary"
                    variant="body1"
                    style={{ marginLeft: 10 }}>
                    Loading...
                  </Typography>
                </Box>
              </Box>) }

              { !isLoading && !isFetching && imageGrid }

            </Route>

            <Route exact path="/imagebank/:imageType/:imageName">
              <IImage />
            </Route>

          </Switch>
        </Box>
      </Paper>
    </>
  );
};


export default Imagebank;
